import styled from 'styled-components';

import { breakpoints, colors, fontFamily, functions } from '../../ui/variables';

const cardWrapper = {
  horizontalPadding: {
    iphone: 16,
  },
  outer: {
    iphone: 40,
  },
};

export const ExamSummaryStyle = styled.div`
  padding: 16px 0 0;

  .exam-summary-title {
    ${fontFamily.sourceSansPro.regular};
    color: ${colors.grayishBlue};
    font-size: 12px;
    line-height: 15px;
    padding: 0 16px;
    text-transform: uppercase;
  }

  .exam-summary-content {
    display: grid;
    grid-template-columns: 1fr
    gap: 16px;
    padding: 12px 16px;
    width: 100%;
    
    .exam-summary-item {
      max-width: 100%;
      min-width: 100%;
      padding: 0

      &:first-child, &:last-child {
        padding: 0;
      }
      
      .item-card-wrapper {
        transition: none;
        height: 100%;
      }
    }
  }

  .exam-summary-navigation {
    display: none;
  }
`;